import { Application } from '@hotwired/stimulus';
import SubmitOnChangeController from './controllers/submit_on_change_controller';
import PlatformSelectController from './controllers/platform_select_controller';

const application = Application.start();

application.debug = false;

application.register('submit-on-change', SubmitOnChangeController);
application.register('platform-select', PlatformSelectController);

window.Stimulus = application;

export default application;
